export const signInRoute = () => 'auth/identity/email-and-password/login';

export const sendOtpRoute = () => `auth/otp`;

export const verifyOtpRoute = () => `auth/verify`;

export const setPasswordRoute = () => `auth/login/resetpassword`;

export const meApiRoute = () => `auth/me`;
